import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import Brands from "./filters/Brands";
// import Colors from "./filters/Colors";
// import Prices from "./filters/Prices";
// import Ratings from "./filters/Ratings";
import Image from "@/components/global/Image";
import { useRouter } from "next/router";
import { findObjectById } from "@/utils/global";
import Link from "next/link";
import { handleLinkByTypeV2 } from "@/helpers/common/handleLinkByType";
import { useGlobalData } from "@/context/global";
import { v4 as uuidv4 } from "uuid";

const SideMenu = ({
  filters,
  selectedFilterKeys,
  setSelectedFilterKeys,
  handleFilter,
  handleResetFilter,
  fromSearch = null,
  t,
  category,
}) => {
  const { locale } = useRouter();
  const context = useGlobalData();
  // console.log("filters", filters);
  return (
    <div className="hidden lg:block col-span-3">
      <button
        disabled={selectedFilterKeys?.length === 0}
        className={`mb-2 p-2 text-white rounded md:w-24 bg-primary-to-b ${
          selectedFilterKeys?.length > 0 ? "" : "opacity-50"
        }`}
        onClick={() => {
          handleResetFilter();
          fromSearch && setSelectedFilterKeys([]);
        }}
      >
        {t("Reset filter")}
      </button>
      {Array.isArray(filters)
        ? filters?.map((item) => {
            const title =
              (item?.label == "فئة" ? "الأقسام الفرعية" : item?.label) || "";
            const options = item?.filterable_values || [];
            const code = item?.filter_key || "";

            let updatedOptions = null;

            // check if code is sub category and have options
            if (code == "category_ids" && options?.length) {
              // loop on options and asigned it into updatedOptions
              updatedOptions = options?.map((option) => {
                // get the data by category id
                const currentCategory = findObjectById(
                  context?.appData?.categoryData?.children_data || [],
                  option?.Key
                );

                // check if currentCategory is_active && currentCategory include_in_menu === "1" && currentCategory product_count > 0 and return the handlate option
                return currentCategory?.is_active &&
                  currentCategory?.include_in_menu === "1" &&
                  currentCategory?.product_count > 0
                  ? { ...option, ...currentCategory }
                  : option;
              });
            }

            // filter box
            return updatedOptions || options?.length ? (
              <div className="mb-3 p-3 rounded-md border" key={uuidv4()}>
                <p className="text-base font-medium sm:text-xl mb-5">{title}</p>
                <Brands
                  {...{
                    data: updatedOptions || options,
                    selectedFilterKeys,
                    code,
                    handleFilter,
                    t,
                  }}
                />
              </div>
            ) : null;
          })
        : null}

      {fromSearch && Array.isArray(fromSearch) ? (
        <div className="mb-3 p-3 rounded-md border">
          <p className="text-base font-medium sm:text-xl mb-2">
            {t(fromSearch?.at(0)?.parentName)}
          </p>
          <Brands
            {...{
              data: fromSearch?.map((item) => ({
                Key: item?.value,
                Label: item?.label,
                DocCount: item?.count,
              })),
              selectedFilterKeys,
              handleFilter,
              t,
            }}
          />
        </div>
      ) : null}

      {/* <div className="mb-3 p-3 rounded-md border">
        <p className="font-bold text-lg sm:text-xl mb-2">Price</p>
        <Prices />
      </div>
      <div className="mb-3 p-3 rounded-md border">
        <p className="font-bold text-lg sm:text-xl mb-2">Colors</p>
        <Colors />
      </div>
      <div className="mb-3 p-3 rounded-md border">
        <p className="font-bold text-lg sm:text-xl mb-2">Ratings</p>
        <Ratings />
      </div> */}
      {category?.vertical_banners?.length > 0 && (
        <Swiper
          key={locale}
          dir={locale === "en" ? "ltr" : "rtl"}
          className="banner-swiper pb-9"
          modules={[Autoplay, Pagination]}
          pagination={{ clickable: true, enabled: true }}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
        >
          {category?.vertical_banners?.map((bnr, i) => (
            <SwiperSlide key={i}>
              <Link
                href={handleLinkByTypeV2(bnr?.url, bnr?.type)}
                className="w-full aspect-[1/1] overflow-hidden relative"
              >
                <Image
                  loading="eager"
                  src={
                    process.env.NEXT_PUBLIC_IMG_BASEURL +
                    "/" +
                    bnr?.banner_image
                  }
                  fill
                  alt={bnr?.title}
                />
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  );
};

export default SideMenu;
